import {
  collection,
  getCountFromServer,
  query,
  where,
} from "firebase/firestore";
import { useEffect, useState } from "react";

import { db } from "@/integrations/firebase/firestore";

export function formatLibraryReportCount(
  count: number | null | undefined,
): string | null {
  if (count == null || !Number.isFinite(count)) return null;

  const wholeCount = Math.floor(count);
  if (wholeCount <= 0) return null;

  if (wholeCount >= 50) {
    const roundedCount = Math.floor(wholeCount / 50) * 50;
    return `${roundedCount}+ gotowych raportów`;
  }

  if (wholeCount === 1) return "1 gotowy raport";

  const mod10 = wholeCount % 10;
  const mod100 = wholeCount % 100;
  if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) {
    return `${wholeCount} gotowe raporty`;
  }

  return `${wholeCount} gotowych raportów`;
}

export function useLibraryReportCount(enabled: boolean): {
  count: number | null;
  loading: boolean;
  error: boolean;
} {
  const [count, setCount] = useState<number | null>(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(false);
  // Reset on the enabled edge during render (React's derived-state pattern) so
  // the effect below only owns the fetch, never a synchronous state reset.
  const [trackedEnabled, setTrackedEnabled] = useState(enabled);
  if (enabled !== trackedEnabled) {
    setTrackedEnabled(enabled);
    setCount(null);
    setLoading(enabled);
    setError(false);
  }

  useEffect(() => {
    if (!enabled) return;

    let active = true;

    const readyReportsQuery = query(
      collection(db, "drugs"),
      where("latest_version", ">=", 1),
    );

    void getCountFromServer(readyReportsQuery)
      .then((snapshot) => {
        if (!active) return;
        setCount(snapshot.data().count);
        setLoading(false);
      })
      .catch((queryError) => {
        console.error("Library report count query failed:", queryError);
        if (!active) return;
        setCount(null);
        setLoading(false);
        setError(true);
      });

    return () => {
      active = false;
    };
  }, [enabled]);

  return { count, loading, error };
}
